import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { SurveyStatus } from '@ps/survey-kernel';
import {
  ChildSurveyFilter,
  Survey,
  SurveySort,
  SurveySocketUpdatePayload,
  SurveyStatusChange,
  SurveyStatusCount,
  SurveyStatusParam,
  SurveyTabStatus,
} from '@ps/survey-utils';

import {
  SurveyStateFilters,
  SurveyRequestContext,
} from '../survey-state.model';

/** Active status tab when a status update succeeds (from {@link selectFilters}). */
export type SurveyListStatusFilter = SurveyStateFilters['status'];

// Commands — dispatched by SurveyActionsFacade
export const SurveyListActions = createActionGroup({
  source: 'Survey List',
  events: {
    Init: props<{ context: SurveyRequestContext }>(),
    Teardown: emptyProps(),
    'Set Filters': props<{ filters: Partial<SurveyStateFilters> }>(),
    'Set Sort': props<{ sort: SurveySort }>(),
    'Load Next Page': emptyProps(),
    Reload: emptyProps(),
    'Set Tab': props<{
      tabId: SurveyTabStatus;
      status: SurveyStatusParam;
    }>(),
    'Cancel Load': emptyProps(),
    'Load Child Surveys': props<{
      parentId: number;
      filter: ChildSurveyFilter;
    }>(),
    'Update Survey Status': props<{ surveyId: number; status: SurveyStatus }>(),
  },
});

// Events — dispatched by effects only, never by components
export const SurveyListApiActions = createActionGroup({
  source: 'Survey List API',
  events: {
    'Load Success': props<{ surveys: Survey[] }>(),
    'Load Failure': props<{ error: string }>(),
    'Load Timeout': emptyProps(),
    'Slow Loading Detected': emptyProps(),
    'Load Counts Success': props<{ counts: SurveyStatusCount }>(),
    'Load Child Surveys Success': props<{
      parentId: number;
      surveys: Survey[];
      /** Set in the effect via `markCached()` from `@ps/utils` (see `docs/caching.md`). */
      cachedAt: number;
    }>(),
    'Load Child Surveys Failure': props<{ parentId: number; error: string }>(),
    'Update Survey Status Success': props<{
      surveyId: number;
      status: SurveyStatus;
      statusFilter: SurveyListStatusFilter;
    }>(),
    'Update Survey Status Failure': props<{
      surveyId: number;
      error: string;
    }>(),
  },
});

export const SurveyListSocketUpdateActions = createActionGroup({
  source: 'Survey List Socket Update',
  events: {
    'Update Survey': props<SurveySocketUpdatePayload>(),
    'Filter Survey By Status': props<SurveyStatusChange>(),
  },
});
